"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.shopStore = void 0;
var shop_1 = require("./shop");
Object.defineProperty(exports, "shopStore", { enumerable: true, get: function () { return shop_1.shopStore; } });
//# sourceMappingURL=index.js.map